<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'SELLER_DETAILS.GENERAL_TAB_LABEL' | translate }}</h3>
    </div>

    <div class="sp-row__align">
      <div class="sp-row__align sp-row__justify-center">
        <mat-icon
          [ngClass]="{
            'sp-color__green': seller?.is_confirmed,
            'sp-color__red': !seller?.is_confirmed && seller?.password_set_at === 0,
            'sp-color__orange': !seller?.is_confirmed && seller?.password_set_at !== 0
          }"
          [matTooltip]="
            seller?.is_confirmed
              ? ('GENERAL.TOOLTIP_CONFIRMED' | translate)
              : seller?.password_set_at === 0
              ? ('GENERAL.TOOLTIP_NOT_CONFIRMED_NO_PASSWORD' | translate)
              : ('GENERAL.TOOLTIP_NOT_CONFIRMED_PASSWORD_SET' | translate)
          ">
          check_circle
        </mat-icon>
        <button
          (click)="onConfirmSellerClick(); $event.stopPropagation()"
          *ngIf="!seller?.is_confirmed && seller?.password_set_at !== 0"
          mat-icon-button
          class="sp-icon__button sp-icon__button-dark sp-margin__left"
          [matTooltip]="'SELLERS.CONFIRM_USER_CTA' | translate">
          <mat-icon class="material-symbols-outlined"> check_circle_outline </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-seller-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'SELLERS.ID_COLUMN_LABEL'"
      [content]="seller?.seller_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'GENERAL.REGISTRATION_DATE_LABEL'"
      [content]="(seller?.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.LAST_LOGIN_LABEL'"
      [content]="(seller?.last_login_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.NAME_LABEL'"
      [content]="getFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.PHONE_LABEL'"
      [content]="getFormattedPhone()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.EMAIL_LABEL'"
      [content]="seller?.email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.PASSWORD_SETTING_DATE_LABEL'"
      [content]="(seller?.password_set_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'SELLERS.SUB_COLUMN_LABEL'"
      [content]="seller?.seller_sub || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'GENERAL.COMPLETED_PROFILE_LABEL'"
      [content]="seller?.is_profile_completed ? 'GENERAL.YES_LABEL' : 'GENERAL.NO_LABEL'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'GENERAL.ORIGIN_INVITATION_LABEL'"
      [content]="seller?.seller_invitation_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.COMPANY_ID_COLUMN_LABEL'"
      [content]="seller?.company_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'SELLERS.BUSINESS_NAME_LABEL'"
      [content]="getCompanyName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'SELLERS.LAST_SIGN_IN_ATTEMPT_LABEL'"
      [content]="(seller?.last_sign_in_attempt_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.PREFERRED_MFA_LABEL'"
      [content]="seller?.preferred_mfa || 'SMS' | uppercase"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'SELLERS.BLOCKED_AT_LABEL'"
      [content]="(seller?.blocked_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'SELLERS.LOCK_REASON_LABEL'"
      [content]="getBlockedReason()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'SELLERS.UNBLOCKED_AT_LABEL'"
      [content]="(seller?.unblocked_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'SELLERS.UNBLOCKED_BY_LABEL'"
      [content]="seller?.unblocked_by || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.LOGIN_ATTEMPTS_LABEL'"
      [content]="seller?.current_login_attempts || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
